import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { AppShell } from "./components/AppShell";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import ProductsPage from "./pages/ProductsPage";
import NewOrderPage from "./pages/NewOrderPage";
import OrdersPage from "./pages/OrdersPage";
import UsersPage from "./pages/UsersPage";
import DashboardPage from "./pages/DashboardPage";
import CustomersPage from "./pages/CustomersPage";
import PurchasesPage from "./pages/PurchasesPage";
import NewPurchasePage from "./pages/NewPurchasePage";

const Protected = ({ admin, staff, children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center font-mono text-sm text-slate-500">Yükleniyor...</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/siparis-olustur" replace />;
  if (staff && user.role === "customer") return <Navigate to="/siparis-olustur" replace />;
  return children;
};

const Guest = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to={user.role === "admin" ? "/" : "/siparis-olustur"} replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/giris" element={<Guest><LoginPage /></Guest>} />
            <Route path="/kayit" element={<Guest><RegisterPage /></Guest>} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Protected admin><DashboardPage /></Protected>} />
              <Route path="/urunler" element={<ProductsPage />} />
              <Route path="/siparis-olustur" element={<NewOrderPage />} />
              <Route path="/siparisler" element={<OrdersPage />} />
              <Route path="/musteriler" element={<Protected staff><CustomersPage /></Protected>} />
              <Route path="/alislar" element={<Protected admin><PurchasesPage /></Protected>} />
              <Route path="/alislar/yeni" element={<Protected admin><NewPurchasePage /></Protected>} />
              <Route path="/kullanicilar" element={<Protected admin><UsersPage /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
